import React, { useState, memo } from 'react';
import classnames from 'classnames';
import { FR_PR_BLACK } from '@shared/styles/vars';
import { Image } from '@src/components/Image';
import { HEX_COLOR_OPACITY } from '@src/util/getHexColorOpacity';
import { AvatarSize } from './enums/avatarSize.enum';
import { AvatarProps } from './props';
import './styles.scss';

export const Avatar = memo<AvatarProps>(
  ({
    size = AvatarSize.MEDIUM,
    source,
    className,
    avatarColor = FR_PR_BLACK,
    initials,
    children,
    opacity = HEX_COLOR_OPACITY[10],
  }) => {
    const [shouldShowImage, setShouldShowImage] = useState(!!source);

    const content = children || initials;

    function setDefaultState() {
      setShouldShowImage(false);
    }

    return (
      <div
        className={classnames('fr-avatar', `fr-avatar--${size}`, className)}
        style={{
          backgroundColor: `${avatarColor}${opacity}`,
          color: avatarColor,
        }}
      >
        {source && shouldShowImage ? (
          <Image alt="" className="fr-avatar__image" setDefaultState={setDefaultState} src={source} />
        ) : (
          content
        )}
      </div>
    );
  },
);

Avatar.displayName = 'Avatar';
